import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EnvelopeShippingDocumentsRoutingModule } from './envelope-shipping-documents-routing.module';
import { EnvelopeShippingDocumentsComponent } from './envelope-shipping-documents.component';
import { EnvelopeSimpleShippingModule } from '../../components/envelope-simple-shipping/envelope-simple-shipping.module';

@NgModule({
  declarations: [EnvelopeShippingDocumentsComponent],
  imports: [
    CommonModule,
    EnvelopeShippingDocumentsRoutingModule,
    EnvelopeSimpleShippingModule
  ]
})
export class EnvelopeShippingDocumentsModule {}
